import {Component, OnInit, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef} from '@angular/core';
import { LKNotification, NOTIFICATIONS$, NotificationService } from './service';
import { Observable } from 'rxjs';
import { SubscribableOrPromise } from 'rxjs/Observable';
import {debounce, map, mapTo} from 'rxjs/operators';
import {Subscription} from "rxjs/Subscription";

@Component({
  selector: 'lk-notification',
  template: `<div class="notification"
     [class.active]="(show$ | async) === true"
     [class.notification--info]="(notification$ | async)?.type === 'info'"
     [class.notification--warning]="(notification$ | async)?.type === 'warning'"
     [class.notification--error]="(notification$ | async)?.type === 'error'"
     [class.notification--success]="(notification$ | async)?.type === 'success'">
  <div class="notification__close">
    <a #close><icon name='close' size="23" color="#fff" stroke></icon></a>
  </div>
  <div class="notification__content">
    <div class="notification__icon {{iconName}}"><icon [name]='iconName' [size]="(iconName === 'warning') ? '25' : '24'" color="#fff"></icon></div>
    <div class="notification__text">
      <truncate [value]="(notification$ | async)?.message" limit="275"></truncate>
    </div>
    <div class="notification__actions"
         [class.notification__actions--line]="(notification$ | async)?.buttons?.length > 1">
      <button *ngFor="let button of (notification$ | async)?.buttons" (click)="button.action()">
        {{ button.label }}
      </button>
    </div>
  </div>
</div>
`,
  styles: [`.notification{position:fixed;z-index:9999;width:800px;bottom:-100px;left:0;right:0;margin:0 auto;padding:10px 20px;border-radius:3px;box-shadow:0 11px 15px rgba(0,0,0,.16);transition:all .4s ease-out .1s;background:#878787}.notification.active{bottom:5px;transition:all .4s ease-out .1s}.notification.active.notification--info{background-color:#0081e3}.notification.active.notification--warning{background-color:#ff7a00}.notification.active.notification--error{background-color:#d80000}.notification.active.notification--success{background-color:#7abf00}.notification .notification__content{display:flex;flex-wrap:wrap;align-items:center;padding:15px 40px 15px 1px}.notification .notification__close{position:absolute;cursor:pointer;top:15px;right:15px}.notification .notification__icon{flex:0 0 auto;width:40px;padding:8px 7px;box-sizing:border-box;align-items:center;justify-content:center;height:39px;border-radius:50%;background-color:rgba(0,0,0,.2)}.notification .notification__icon.warning{padding:7px}.notification .notification__text{padding:0 40px 0 20px;font-size:14px;font-weight:400;color:#fff;flex:1 1 auto;flex-basis:530px}.notification .notification__actions{font-size:14px;font-weight:400;color:#fff;flex:0 0 auto}.notification .notification__actions.notification__actions--line{padding:25px 0 0 85px}.notification .notification__actions button{background:0 0;font-size:14px;font-weight:400;color:#fff;padding:10px 25px;margin-right:10px;border:1px solid #fff;border-radius:40px;cursor:pointer}`],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationComponent implements OnInit {

  @ViewChild('close') private closeButton;
  public notification$: Observable<LKNotification>;
  public show$: Observable<boolean>;
  public iconName: string = 'info';
  private _subscription: Subscription;

  constructor(private _detectorRef: ChangeDetectorRef) {}

  ngOnInit() {
    this._subscription = NOTIFICATIONS$.subscribe(notification => {
      this.iconName = ( notification.type !== 'success' ) ? notification.type : 'info';
      this._detectorRef.markForCheck();
    });
    this.notification$ = NOTIFICATIONS$;
    this.show$ = Observable.merge(
      this.notification$.pipe(mapTo(true)),
      this.notification$.pipe(
        debounce(() => NotificationComponent.getTimeout()),
        mapTo(false),
      ),
      Observable.fromEvent(this.closeButton.nativeElement, 'click').pipe(mapTo(false))
    ).distinctUntilChanged();
  }

  /**
   * Return the timer to debouncing notification
   */
  private static getTimeout(): SubscribableOrPromise<number> {
    return Observable.timer(NotificationService.timer);
  }
}
